import { useQuery } from "@apollo/client";
import { MY_LEAVE_GET_EXAMINERS_NAME } from "my-leave/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyLeaveExaminersName = ({ locale }: { locale: string }) => {
  const { data, loading, error } = useQuery(MY_LEAVE_GET_EXAMINERS_NAME, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    variables: { locale },
  });

  const result = data?.getExaminersName || [];

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyLeaveExaminersName;
